import Axios from 'axios';
import auth from '@/utils/auth';

export const HTTP_ORGANIZATIONS = Axios.create({
  baseURL: `${process.env.API_ORGANIZATIONS}/${process.env.API_ORGANIZATIONS_VERSION}`,
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

export const HTTP_CAMPAIGNS = Axios.create({
  baseURL: `${process.env.API_MASSEMISSION}/${process.env.API_MASSEMISSION_VERSION}`,
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

export const HTTP_DESKRH = Axios.create({
  baseURL: `${process.env.API_DESKRH}/${process.env.API_DESKRH_VERSION}`,
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

export const HTTP_USERS = Axios.create({
  baseURL: `${process.env.API_USERS}/${process.env.API_USERS_VERSION}`,
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

export const HTTP_DOCUMENTS = Axios.create({
  baseURL: `${process.env.API_DOCUMENTS}/${process.env.API_DOCUMENTS_VERSION}`,
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

export const HTTP_CONF = Axios.create({
  baseURL: '/static',
  timeout: process.env.TIMEOUT,
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
});

// clear session informations on logout when session expires
export function clearSessionInformation() {
  localStorage.removeItem('session');
  localStorage.removeItem('refreshToken');
  delete HTTP_ORGANIZATIONS.defaults.headers.common.Authorization;
  delete HTTP_CAMPAIGNS.defaults.headers.common.Authorization;
  delete HTTP_DESKRH.defaults.headers.common.Authorization;
  delete HTTP_USERS.defaults.headers.common.Authorization;
  delete HTTP_DOCUMENTS.defaults.headers.common.Authorization;
  delete HTTP_ORGANIZATIONS.defaults.headers.common['Refresh-Token'];
  delete HTTP_CAMPAIGNS.defaults.headers.common['Refresh-Token'];
  delete HTTP_DESKRH.defaults.headers.common['Refresh-Token'];
  delete HTTP_USERS.defaults.headers.common['Refresh-Token'];
  delete HTTP_DOCUMENTS.defaults.headers.common['Refresh-Token'];
}


// set authorization to token for all axios requests
export function setAuthorization(token) {
  HTTP_ORGANIZATIONS.defaults.headers.common.Authorization = token;
  HTTP_CAMPAIGNS.defaults.headers.common.Authorization = token;
  HTTP_DESKRH.defaults.headers.common.Authorization = token;
  HTTP_USERS.defaults.headers.common.Authorization = token;
  HTTP_DOCUMENTS.defaults.headers.common.Authorization = token;
}

// update auhorization according to the ones receive in response header
export function updateAuthorization(response) {
  if (response) {
    if (response.headers && response.headers['set-authorization']) {
      const session = auth.getSession();
      if (session) {
        session.token = response.headers['set-authorization'];
        setAuthorization(`Bearer ${session.token}`);
        localStorage.setItem('session', JSON.stringify(session));
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/http.js